import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { api } from '../../../Services/API'
import { useSubmitPetsInfoStore } from '../../../Stores/useSubmitPetsInfoStore'

import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  SubmitPetsInfoRequest,
  SubmitPetsInfoResponse,
} from '../../../@types/SubmitPetsInfo'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: SubmitPetsInfoRequest) => {
  const response = await api.post<SubmitPetsInfoResponse>(
    API_ROUTES.submitPetsInfo,
    payload,
  )

  return response.data
}

export const useSubmitPetsInfo = () => {
  const { setSubmitPetsInfo } = useSubmitPetsInfoStore()
  const { handleErrorRequest } = useErrorRequest()
  return useMutation({
    mutationFn: (payload: SubmitPetsInfoRequest) => request(payload!),
    onSuccess(data) {
      setSubmitPetsInfo(data)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
